import React from 'react'
import './manufactureinsurance.scss'
import { Hero, MainHeading, Breadcrumb, ManufacturingInsurance, FindAgent, CommonTabs, NewsCard, Faq, SuccessStories, CommonBlueCards , RequestQuote } from '../../../components';
import { images } from "../../../utils/customFn";
import { Container } from 'react-bootstrap';
const ManufactureInsurance = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "Who we serve", link: "/who-we-serve/" },
    { label: "Insurance For Manufacturing Businesses", link: "/whoweserve/manufactureinsurance" },
  ];

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  const ProductCardData = [
    {
      id: 1,
      title: 'Electronic component manufacturing insurance',
      description:
        'We know how important your electronic manufacturing business and your employees are to you. Let us help protect them.',
      linkUrl: '',
      linkText: 'More about electronic manufacturing  >',
    },
    {
      id: 2,
      title: 'Food processing insurance',
      description:
        'Protection for your lot, your sales and service staff, and your customers.',
      linkUrl: '/',
      linkText: 'More about food processing insurance >',
    },
    {
      id: 3,
      title: 'Metalworking insurance',
      description:
        'From bass boats to pontoons, we’ll help protect the business that keeps you afloat.',
      linkUrl: '/',
      linkText: 'More about metalworking insurance >',
    },
  ];

  const ResourceData = [
    {
      id: 1,
      title: 'Manufacturing resources',
      description:
        'Explore our resources, featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.',
      linkUrl: '',
      linkText: 'View resources >',
    },
    {
      id: 2,
      title: '2024 Manufacturing Injury Report',
      description:
        'Discover the latest trends, risks, and costs involving workplace injuries in the manufacturing industry.',
      linkUrl: '/',
      linkText: 'Download report >',
    },
  ];

  const tabsData = [
    {
      id: "coverage",
      href: "#coverage",
      label: "Coverage options",
    },
    {
      id: "weserve",
      href: "#/",
      label: "Our manufacturing customers",
    },
  ];
  
  const activeTabId = "thesentry";

  const FaqData = [
    {
      id: 1,
      eventKey: "0",
      header: "What are your giving criteria?",
      body: "We focus our giving efforts on education, workforce development, and local organizations working to improve quality of life and build stronger, more equitable communities where Sentry employees live and work. We don’t give to individuals, political or lobbying organizations, or third-party fundraisers."
    },
    {
      id: 2,
      eventKey: "1",
      header: "Where do you give geographically?",
      body: "We give where our associates live and work. This includes Stevens Point, where Sentry is headquartered, the island of Maui—our home away from home—and the communities where our field offices are located."
    },
    {
        id: 3,
        eventKey: "2",
        header: "Who should I contact for more information?",
        body: "Kalynn Pempek is the Sentry Insurance Foundation Executive Director and can be reached via email at kalynn.pempek@sentry.com or by phone at 715-346-7636."
    }
  ];


  return (
    <>
      <div className='manufacture-main'>
        {/* hero section */}
        <Hero img={images["hero-manufacturing-insurance.avif"]} />
        <Container>
          {/* Breadcrumb */}
          <Breadcrumb crumbs={breadcrumbs} />

          {/* heading  */}
          <MainHeading title="Manufacturing insurance" showshare={false} />

          {/* tabs */}
          <CommonTabs tabs={tabsData} activeTab={activeTabId} />

          {/* page content main*/}
          <ManufacturingInsurance/>

          {/* we serve */}
          <NewsCard Title="Manufacturing businesses we serve" CardData={ProductCardData} showNavLink={false} subTitle=" " />

          {/* request a quote  */}
          <RequestQuote/>

          {/* Faq */}
          <Faq FaqData={FaqData} heading={'FAQs'}/>

          {/* stories */}
          <SuccessStories />

          {/* common blue cards  */}
          <CommonBlueCards CardData={ResourceData} Title="Related resources" />

          {/* find agent */}
          <FindAgent options={Selectoptions} />
        </Container>
      </div>
    </>
  )
}

export default ManufactureInsurance